import React, { useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ProductsList } from "./ProductsList";
import { CartContext } from "./cartContext";
import { WishlistContext } from "./Wishlistcontext";
import { CurrencyContext } from "./CurrencyContext";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";


export default function ProductDetails() {
  const [activeTab, setActiveTab] = useState("Description");
  const [cartClicked, setCartClicked] = useState(false);
  const [wishClicked, setWishClicked] = useState(false);
  const [cartMessage, setCartMessage] = useState("");
  const [wishlistMessage, setWishlistMessage] = useState("");
  const { currencySign, convertPrice } = useContext(CurrencyContext);
  const navigate = useNavigate();

  const { id, category } = useParams();
  const product = ProductsList[category].products.find((p) => p.id == id);

  const { addToCart, cartItems } = useContext(CartContext);
  const { addToWishlist, removeFromWishlist, wishlistItems } =
    useContext(WishlistContext);
  const getUID = (product) =>
    `${product.category}-${product.id}-${product.name}`;

  const isInCart = cartItems.some((item) => getUID(item) === getUID(product));
  const isInWishlist = wishlistItems.some(
    (item) => getUID(item) === getUID(product)
  );

  const handleAddToCart = () => {
    if (!isInCart) {
      addToCart(product);
      setCartMessage("✅ Product added to cart!");
    } else {
      setCartMessage("🛒 Product already in your cart!");
    }
    setCartClicked(true);
    setTimeout(() => {
      setCartClicked(false);
      setCartMessage("");
    }, 2000);
  };

  const handleWishlistToggle = () => {
    setWishClicked(true);
    if (isInWishlist) {
      removeFromWishlist(product);
      setWishlistMessage("Removed From Wishlist");
    } else {
      setWishlistMessage("Added to Wishlist");
      addToWishlist(product);
    }
    setTimeout(() => {
      setWishClicked(false);
      setWishlistMessage("");
    }, 2000);
  };

  return (
    <>
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <button
            onClick={()=>navigate(-1)}
            className="flex items-center text-gray-700 hover:text-[#fe7590] cursor-pointer"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back
          </button>
        </div>
      </header>
      <div className="bg-gray-50 py-12">
        <div className="max-w-6xl mx-auto px-4 lg:px-0">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 bg-white rounded-2xl shadow-2xl p-6">
            {/* Product Images */}
            <div className="space-y-4">
              <div className="relative overflow-hidden rounded-xl shadow-lg group">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-[450px] object-contain transition-transform duration-500 group-hover:scale-105"
                />
                {product.sale_price && (
                  <span className="absolute top-4 left-4 bg-[#fe7590] text-white px-3 py-1 rounded-full font-semibold text-sm shadow-lg">
                    SALE
                  </span>
                )}
              </div>

              {/* Thumbnails */}
              <div className="flex gap-3 justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-20 h-20 object-cover rounded-lg cursor-pointer border-2 border-gray-200 hover:border-[#fe7590] transition"
                />
              </div>
            </div>

            {/* Product Info */}
            <div className="flex flex-col gap-4">
              <h1 className="text-3xl font-extrabold text-gray-900">
                {product.name}
              </h1>
              {/* <span className="text-gray-500 text-sm">({product.reviews || 42} Reviews)</span> */}

              <div className="flex items-center gap-3">
                <p className="text-3xl font-bold text-[#fe7590]">
                  {currencySign}
                  {convertPrice(product.sale_price) ||
                    convertPrice(product.price)}
                </p>
                {product.sale_price && (
                  <span className="line-through text-gray-400 text-lg">
                    {currencySign}
                    {convertPrice(product.price)}
                  </span>
                )}
              </div>

              <p className="text-gray-700 leading-relaxed">
                {product.description}
              </p>

              {/* Buttons */}
              <div className="flex gap-4 mt-6 flex-wrap">
                <button
                  onClick={handleAddToCart}
                  className={`flex items-center justify-center gap-2 py-3 px-6 rounded-lg font-semibold border transition-all duration-300 cursor-pointer ${
                    isInCart
                      ? "bg-green-100 text-green-700 border-green-300 hover:bg-green-200"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-red-100 hover:text-[#fe7590] shadow-md hover:shadow-lg"
                  }`}
                >
                  <img
                    src="/assests/icons/addtocart.png"
                    alt="Add to Cart"
                    className={`w-6 h-6 transition-transform duration-500  ${
                      cartClicked ? "rotate-[360deg] scale-125" : "scale-100"
                    }`}
                  />
                  {isInCart ? "In Cart" : "Add to Cart"}
                </button>

                <button
                  onClick={handleWishlistToggle}
                  className={`flex items-center justify-center gap-2 py-3 px-6 rounded-lg font-semibold border transition-all duration-300 cursor-pointer ${
                    isInWishlist
                      ? "bg-red-100 text-[#fe7590] border-red-300  shadow-md"
                      : "bg-white text-gray-700 border-gray-300  hover:text-[#fe7590] shadow-md hover:shadow-lg"
                  }`}
                >
                  <img
                    src={
                      isInWishlist
                        ? "/assests/icons/wa.png"
                        : "/assests/icons/w.png"
                    }
                    alt="Wishlist"
                    className={`w-6 h-6 transition-transform duration-500 ${
                      wishClicked ? "rotate-[360deg] scale-125" : "scale-100"
                    }`}
                  />
                  {/* {isInWishlist ? "Remove from Wishlist" : "Add to Wishlist"} */}
                </button>
              </div>

              {cartMessage && (
                <p className="mt-2 text-green-600 font-medium animate-fadeIn">
                  {cartMessage}
                </p>
              )}
              {wishlistMessage && (
                <p className="mt-2 text-green-600 font-medium animate-fadeIn">
                  {wishlistMessage}
                </p>
              )}

              {/* Tabs: Description / Details */}
              <div className="mt-8">
                <div className="flex border-b border-gray-200">
                  <button
                    key={"details"}
                    // onClick={() => setActiveTab(tab)}
                    className={`py-2 px-4 -mb-px font-semibold border-b-2 transition cursor-pointer 
                    border-[#fe7590] text-[#fe7590]"
                    `}
                  >
                    Details
                  </button>
                </div>
                <div className="mt-4 text-gray-700 leading-relaxed">
                  {product.details}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
